module.exports = __webpack_public_path__ + "static/media/033.7d065e21.png";